var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4841 8.58882L3.2387 3.06546C2.97822 2.99437 2.70363 2.98097 2.43666 3.02631C2.16968 3.07165 1.91764 3.17449 1.70047 3.3267C1.4833 3.47891 1.30695 3.67631 1.18538 3.90329C1.06381 4.13027 1.00034 4.38061 1 4.6345V19.3635C1 19.7975 1.18427 20.2138 1.51227 20.5207C1.84027 20.8276 2.28513 21 2.74899 21C2.91623 21.0001 3.08262 20.9777 3.24308 20.9335L12.3684 18.313V19.3635C12.3684 19.7975 12.5527 20.2138 12.8807 20.5207C13.2087 20.8276 13.6535 21 14.1174 21H17.6154C18.0792 21 18.5241 20.8276 18.8521 20.5207C19.1801 20.2138 19.3644 19.7975 19.3644 19.3635V16.3051L22.4841 15.4102C22.8452 15.3086 23.1619 15.1013 23.3874 14.8186C23.6129 14.5359 23.7354 14.1929 23.7368 13.8401V10.1579C23.7352 9.80526 23.6126 9.46247 23.3871 9.17999C23.1615 8.89751 22.845 8.69028 22.4841 8.58882ZM17.6154 19.3635H14.1174V17.8108L17.6154 16.8063V19.3635ZM21.9879 13.8401H21.9758L14.1174 16.0985V7.8984L21.9758 10.1579H21.9879V13.8401Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.2d2bf2e000249240a0b4ce0cfb459d4a.svg";
export { ForwardRef as ReactComponent };